import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { DirectedCastRole } from 'fym-shared/src/music24/directedVideoApi';
import { TypedMemo } from '../../common/types';
import { castMessages } from '../messages/castMessages';
import { CAST_ROLE_MESSAGES, CAST_ROLES } from './castRoleMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import styles from '../DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CastRolesProps {
  value: DirectedCastRole;
  /** The name of the picture, for the label of the group. */
  label: string;
  disabled?: boolean;
  onChange: (role: DirectedCastRole) => void;
}

/** The four roles of a cast picture as one segmented control (design `.roles`): Person, Place, Object, Style. */
const CastRolesComponent: React.FC<CastRolesProps> = ({ value, label, disabled = false, onChange }) => {
  const intl = useIntl();
  return (
    <div className={styles.roles} role="radiogroup" aria-label={intl.formatMessage(castMessages.rolesLabel, { label })}>
      {CAST_ROLES.map((role) => (
        <button
          key={role}
          type="button"
          role="radio"
          aria-checked={role === value}
          className={clsx(role === value && styles.roleOn)}
          disabled={disabled}
          onClick={() => {
            if (role !== value) {
              onChange(role);
            }
          }}
        >
          {intl.formatMessage(CAST_ROLE_MESSAGES[role])}
        </button>
      ))}
    </div>
  );
};

export const CastRoles = TypedMemo(CastRolesComponent);
